import React from 'react';
import SkeletonElement from '../../../SkeletonElement';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function SkeletonGeneralOffer(_ref) {
  var shape = _ref.shape;
  var addCssByShape = function addCssByShape() {
    switch (shape) {
      case 'square':
        return 'w-[250px] h-[250px]';
      case 'rectangle':
        return 'w-[500px]';
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    className: " shadow-xl p-2 min-w-[300px] rounded-xl",
    children: [/*#__PURE__*/_jsx(SkeletonElement, {
      type: "thumbnail",
      size: "h-[300px] w-full"
    }), /*#__PURE__*/_jsx(SkeletonElement, {
      type: "title"
    }), /*#__PURE__*/_jsx(SkeletonElement, {
      type: "text"
    })]
  });
}
export default SkeletonGeneralOffer;